<template>
  <component :is="renderContent ? 'div' : 'vs-popup'" :class="'asset-modal public-3d-modal'" :title="assetWithId" :active.sync="popupActive" >
    <div class="d-flex w-100" style="flex-direction: column;background-image: linear-gradient(135deg, #2a2399, #098cf1);">
      <iframe :src="src"
              width="100%"
              height="100%"
      />
    </div>
    <div class="loader-block bg-transparent" v-if="isLoading">
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
  </component>
</template>

<script>
const iframeUrl = `https://blob-jiocdn.embibe.com/coobo/teach_lite_3d_viewer_test/lite.html`
export default{
  props: {
    renderContent: {type: Boolean, default: false},
    asset: {type: Object},
    locale: {type: String, default: 'en'}
  },
  data () {
    return {
      popupActive: true,
      isLoading: true,
      bodyOverflow: "",
    }
  },
  mounted () {
    this.bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("message", this.onAssetReady)
  },
  destroyed() {
    document.body.style.overflow = this.bodyOverflow;
    window.removeEventListener("message", this.onAssetReady)
  },
  methods: {
    onAssetReady(e) {
      if (iframeUrl.startsWith(e.origin) && e.data && e.data.action === "assetReady") {
        this.isLoading = false;
      }
    },
  },
  computed: {
    src() {
      return `${iframeUrl}?id=asset-${this.asset.variants_data.coobo_library_link.split('/').pop()}&locale=${this.locale}`
    },
    assetWithId() {
      return `${this.asset.title}` // - ${this.asset.asset_object_id}`
    }
  },
  watch: {
    popupActive(next) {
      if (!next) {
        this.$emit('close');
      }
    }
  }
}
</script>
<style>
.asset-modal.public-3d-modal {
  width: 100%;
  height: 100%;
  display: flex;
}
.asset-modal.public-3d-modal iframe {
  border: none;
}
.asset-modal.public-3d-modal .vs-popup {
  margin: 0;
  max-height: 100%;
  padding: 0;
  width: calc(100% - 30px);
  height: calc(100% - 30px);
}
.asset-modal.public-3d-modal.con-vs-popup .vs-popup--content {
  width: 100%;
  height: 100%;
  max-height: 100%;
  margin: 0;
  padding: 0;
}
.loader-block .loading {
  top: 50%;
}
</style>
